import { Injectable, ViewContainerRef, ComponentFactoryResolver } from '@angular/core';
import { SpinnerComponent } from './spinner.component';
 
@Injectable()
export class SpinnerService {
  currentSpinny: any = null;
  public defaultViewContainer: ViewContainerRef;
  constructor(private componentFactoryResolver: ComponentFactoryResolver) {
  }
 
  public start() {
    if (this.currentSpinny === null) {
      let spinnyCompFactory = this.componentFactoryResolver.resolveComponentFactory(SpinnerComponent);
      this.currentSpinny = this.defaultViewContainer.createComponent(spinnyCompFactory);
    }
  }
 
  public stop() {
    if (this.currentSpinny !== null) {
      this.currentSpinny.destroy();
      this.currentSpinny = null;
    }
  }
}


// WEBPACK FOOTER //
// ./src/app/_services/spinner.service.ts